/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const it: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'cancella',
    facetsHeader: 'Filtri'
  },
  close: { buttonText: '' },
  facets: {
    defaultRange: { fromHTML: 'più di {min}' },
    titles: {
      price_facet: 'Prezzo',
      sizes_facet: 'Taglia',
      color_facet: 'Colore'
    },
    toggle: {
      default: {
        openHTML: 'Filtra {numFound} risultati',
        closeHTML: 'Mostra {numFound} risultati'
      }
    }
  },
  history: {
    disable: 'on',
    enable: 'off'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['']
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__mgoccessage-apologies">Non abbiamo trovato nessun risultato per </span>
         <span class="ebx-no-results__message-query">{query}'</span><span class="ebx-no-results__message-try-again">
        Questi sono i prodotti più vi</span>`
  },
  nextQueries: {
    titleHTML: 'Potresti essere interessato',
    nextQuery: {
      titleHTML: 'Altri utenti hanno cercato <span class="ebx-next-query__title-query">{query}</span>'
    }
  },
  partialResult: {
    messageHTML: `<span class="ebx-partials__message-apologies">Non abbiamo potuto trovare nessun risultato per </span><span class="ebx-partials__message-query">'{query}'</span><span class="ebx-partials__message-try-again"> Prodotti che potrebbero interessarti</span>`,
    titleHTML: '<span class="ebx-partial-result__title-num-found">{numFound}</span> risultati per <span class="ebx-partial-result__title-term">{term}</span>'

  },
  sort: {
    titleHTML: 'Ordina per {selectedItem}',
    sortTitles: {
      default: 'Rilevanza',
      priceAsc: 'Prezzo crescente',
      priceDesc: 'Prezzo discendente',
      alphabeat: 'Alfabetico'
    }
  }
};
